import {
  browserTracingIntegration,
  init,
  replayIntegration,
} from "@sentry/remix";
/**
 * By default, Remix will handle hydrating your app on the client for you.
 * You are free to delete this file if you'd like to, but if you ever want it revealed again, you can run `npx remix reveal` ✨
 * For more information, see https://remix.run/file-conventions/entry.client
 */

import { RemixBrowser, useLocation, useMatches } from "@remix-run/react";
import i18next from "i18next";
import Backend from "i18next-http-backend";
import { startTransition, StrictMode, useEffect } from "react";
import { hydrateRoot } from "react-dom/client";
import { I18nextProvider, initReactI18next } from "react-i18next";
import i18n from "./i18n";
import enCommon from "./locales/en.json";
import itCommon from "./locales/it.json";

const isLocal =
  typeof window !== "undefined" &&
  (window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1" ||
    window.location.hostname.includes("localhost"));

if (!isLocal) {
  init({
    dsn: "https://25963ef22f962b91677380d636a11c69@o4510589099114496.ingest.de.sentry.io/4510589102522448",
    tracesSampleRate: 1,
    enableLogs: true,

    integrations: [
      browserTracingIntegration({
        useEffect,
        useLocation,
        useMatches,
      }),
      replayIntegration({
        maskAllText: true,
        blockAllMedia: true,
      }),
    ],

    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1,
    sendDefaultPii: true,
  });
}

async function hydrate() {
  const lng = document.documentElement.lang || undefined;

  await i18next
    .use(initReactI18next)
    .use(Backend)
    .init({
      ...i18n,
      lng,
      resources: {
        it: { common: itCommon },
        en: { common: enCommon },
      },
    });

  startTransition(() => {
    hydrateRoot(
      document,
      <I18nextProvider i18n={i18next}>
        <StrictMode>
          <RemixBrowser />
        </StrictMode>
      </I18nextProvider>
    );
  });
}

if (window.requestIdleCallback) {
  window.requestIdleCallback(hydrate);
} else {
  window.setTimeout(hydrate, 1);
}
